/**
 * Copies items to new array
 */
if (!Array.prototype.softCopy)
	/*eslint no-extend-native: [0]*/
	Object.defineProperty(Array.prototype, "softCopy", {
		value: softCopyArray,
		enumerable: false,
	});

function softCopyArray<T>() {
	const thisArr = this as Array<T>;
	return thisArr.map((i) => i);
}

if (!Array.prototype.hardCopy)
	/*eslint no-extend-native: [0]*/
	Object.defineProperty(Array.prototype, "hardCopy", {
		value: hardCopyArray,
		enumerable: false,
	});

/**
 * Makes a full copy of every item in array, so we can't modify original at all
 */
function hardCopyArray<T>() {
	const thisArr = this as Array<T>;
	return thisArr.map((i) => {
		return { ...i };
	});
}

if (!Array.prototype.groupBy)
	Object.defineProperty(Array.prototype, "groupBy", {
		value: groupByArray,
		enumerable: false,
	});
function groupByArray<T, TKey>(keyGetter: (o: T) => TKey) {
	const map = new Map<TKey, T[]>();
	const thisArr = this as Array<T>;
	thisArr.forEach((item) => {
		const key = keyGetter(item);
		const collection = map.get(key);
		if (!collection) {
			map.set(key, [item]);
		} else {
			collection.push(item);
		}
	});
	return map;
}

//Just here so the compiler doesn't get miserable
export const b = "asdf";

declare global {
	interface Array<T> {
		softCopy(): T[];
		hardCopy(): T[];
		groupBy<TKey>(keyGetter: (o: T) => TKey): Map<TKey, T[]>;
	}
}
